export type SessionTableStateValue = string | number | string[] | null | undefined;

export type SessionTableState = Record<string, SessionTableStateValue>;

const cleanSessionTableState = (state: SessionTableState): SessionTableState => {
  const cleaned: SessionTableState = {};

  Object.entries(state).forEach(([key, value]) => {
    if (value == null || value === '') return;
    if (Array.isArray(value)) {
      const filtered = value.filter(Boolean);
      if (filtered.length > 0) cleaned[key] = filtered;
      return;
    }
    cleaned[key] = value;
  });

  return cleaned;
};

export function readSessionTableState(storageKey: string): SessionTableState {
  if (typeof sessionStorage === 'undefined') return {};

  try {
    const raw = sessionStorage.getItem(storageKey);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

export function writeSessionTableState(storageKey: string, state: SessionTableState): void {
  if (typeof sessionStorage === 'undefined') return;

  const cleaned = cleanSessionTableState(state);
  if (Object.keys(cleaned).length === 0) {
    sessionStorage.removeItem(storageKey);
    return;
  }

  sessionStorage.setItem(storageKey, JSON.stringify(cleaned));
}

export function getSessionString(state: SessionTableState, key: string, fallback = ''): string {
  const value = state[key];
  return typeof value === 'string' ? value : fallback;
}

export function getSessionArray(state: SessionTableState, key: string): string[] {
  const value = state[key];
  return Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string' && item.length > 0) : [];
}

export function getSessionNumber(state: SessionTableState, key: string, fallback: number): number {
  const raw = state[key];
  const value = typeof raw === 'number' ? raw : typeof raw === 'string' ? Number(raw) : NaN;
  return Number.isFinite(value) && value >= 0 ? value : fallback;
}
